import { SwipeableDrawer } from '@mui/material';

import { useBooleanStateAtom } from '../../../utils/booleanState';
import { ReturnComponent } from '../../../utils/reactTypes';
import { isGlobalDrawerOpenAtom } from '../lib/constants';
import { GlobalDrawerItems } from './GlobalDrawerItems';
import { GlobalMobileAppBar } from './GlobalMobileAppBar';

export const GlobalMobileNavigationDrawer = (): ReturnComponent => {
    const [isDrawerOpen, openDrawer, closeDrawer] = useBooleanStateAtom(isGlobalDrawerOpenAtom);

    return (
        <>
            <GlobalMobileAppBar />
            <SwipeableDrawer
                anchor={'left'}
                open={isDrawerOpen}
                onOpen={openDrawer}
                onClose={closeDrawer}
            >
                <GlobalDrawerItems />
            </SwipeableDrawer>
        </>
    );
};
